import React, { useState } from 'react';
import { Brain, Grid3x3, Anchor, Trophy, Users, Play, Sparkles, Check, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../components/ui/dialog';
import { useAuth } from '../context/AuthContext';
import api from '../lib/api';
import { toast } from 'sonner';

const QUIZ_BANK = [
  { q: 'An alien lands on Earth. What\u2019s the first thing most humans show it?', a: ['Peace treaty','Their pet','Their phone','Their passport'], correct: 2 },
  { q: 'What\u2019s the most dangerous phrase in a relationship?', a: ['Good morning','We need to talk','Thank you','How are you?'], correct: 1 },
  { q: 'If you could teleport anywhere right now, where would most people go?', a: ['Work','School','Beach','Dentist'], correct: 2 },
  { q: 'What\u2019s humanity\u2019s most used superpower?', a: ['Flying','Invisibility','Procrastination','Time travel'], correct: 2 },
  { q: 'What disappears fastest?', a: ['Ice cream','WiFi','Salary after payday','Water'], correct: 2 },
  { q: 'An alien asks why humans stare at glowing rectangles all day. What is it talking about?', a: ['TV','Microwave','Smartphones','Mirrors'], correct: 2 },
  { q: 'What\u2019s the strongest force in the universe?', a: ['Gravity','Love','Curiosity','Low battery panic'], correct: 3 },
  { q: 'If aliens judged Earth by social media, what would they conclude?', a: ['Humans love nature','Humans love food and drama','Humans are peaceful','Humans sleep a lot'], correct: 1 },
  { q: 'What is the official language of the internet?', a: ['English','Spanish','Emoji','French'], correct: 2 },
  { q: 'Which pet secretly believes it owns the house?', a: ['Dog','Fish','Cat','Hamster'], correct: 2 },
  { q: 'What is most likely hiding under your bed?', a: ['Treasure','Monster','Dust','Alien'], correct: 2 },
  { q: 'Which invention changed humanity forever?', a: ['Wheel','Internet','Pizza delivery','Electricity'], correct: 2 },
  { q: 'What\u2019s the hardest question in adulthood?', a: ['What is love?','What\u2019s for dinner?','What is success?','What is happiness?'], correct: 1 },
  { q: 'If Earth had a warning label, what would it say?', a: ['Welcome','Handle with care','Contains humans','No entry'], correct: 2 },
  { q: 'Which thing always vanishes when needed?', a: ['Charger','Friend','Phone','Wallet'], correct: 0 },
  { q: 'What\u2019s the real purpose of alarm clocks?', a: ['Timekeeping','Waking people','Daily suffering','Decoration'], correct: 2 },
  { q: 'If aliens made a documentary about Earth, what would it focus on?', a: ['Technology','Politics','Cat videos','History'], correct: 2 },
  { q: 'What is every traveler\u2019s greatest fear?', a: ['Missing luggage','Missing passport','Missing flight','Low battery at the airport'], correct: 3 },
  { q: 'What\u2019s the unofficial sport of the internet?', a: ['Football','Arguing in comments','Basketball','Swimming'], correct: 1 },
  { q: 'Which creature would survive the longest in a zombie apocalypse?', a: ['Human','Cat','Panda','Goldfish'], correct: 1 },
  { q: 'If Mars had WiFi, what would humans do first?', a: ['Explore','Build homes','Post selfies','Study rocks'], correct: 2 },
  { q: 'What\u2019s more powerful than a spaceship?', a: ['Rocket','Black hole','Grandma with a slipper','Meteor'], correct: 2 },
  { q: 'Which emoji is the king of all emojis?', a: ['\u2764\ufe0f','\ud83d\udc4d','\ud83d\ude02','\ud83d\ude0e'], correct: 2 },
  { q: 'What\u2019s humanity\u2019s favorite hobby?', a: ['Reading','Sleeping','Running','Painting'], correct: 1 },
  { q: 'What happens immediately after cleaning your room?', a: ['It stays clean','It gets messy again','You move','Nothing'], correct: 1 },
  { q: 'What\u2019s the biggest lie on Earth?', a: ['I\u2019m fine','I\u2019ll sleep early tonight','See you soon','Trust me'], correct: 1 },
  { q: 'If aliens joined WorldVibe, what rank would they want?', a: ['Explorer','Astronaut','Supreme Being','Traveler'], correct: 2 },
  { q: 'What runs faster than light?', a: ['Rocket','Gossip','Airplane','WiFi'], correct: 1 },
  { q: 'Which food causes the most arguments?', a: ['Burger','Pasta','Pineapple Pizza','Salad'], correct: 2 },
  { q: 'What is the true purpose of refrigerators?', a: ['Store food','Keep things cold','Give people something to check every 5 minutes','Save energy'], correct: 2 },
  { q: 'What\u2019s the first thing people do after taking a group photo?', a: ['Save it','Share it','Zoom in on themselves','Delete it'], correct: 2 },
  { q: 'If you had one extra hour every day, what would most people do?', a: ['Learn','Exercise','Scroll more social media','Work'], correct: 2 },
  { q: 'What\u2019s the real reason people go to the gym?', a: ['Health','Fitness','Photos and motivation','Air conditioning'], correct: 2 },
  { q: 'Which thing is impossible to find when needed?', a: ['Remote control','Phone','TV','Chair'], correct: 0 },
  { q: 'What would be Earth\u2019s most valuable export?', a: ['Technology','Music','Memes','Coffee'], correct: 2 },
  { q: 'What\u2019s more addictive than space travel?', a: ['Coffee','Notifications','Music','Pizza'], correct: 1 },
  { q: 'Which planet would be the worst vacation destination?', a: ['Earth','Mars','Venus','Neptune'], correct: 2 },
  { q: 'What\u2019s humanity\u2019s greatest achievement?', a: ['Moon landing','Internet','Being able to order food without speaking to anyone','Electricity'], correct: 2 },
  { q: 'If a UFO landed in your backyard, what would most people do first?', a: ['Run','Call scientists','Record a video','Hide'], correct: 2 },
  { q: 'What is the secret to becoming a Supreme Being on WorldVibe?', a: ['Money','Luck','XP and activity','Magic'], correct: 2 },
];

export default function Games() {
  const navigate = useNavigate();
  return (
    <div className="space-y-5">
      <div>
        <h1 className="font-display font-bold text-2xl md:text-3xl">Cosmic Arcade</h1>
        <p className="text-white/60 text-sm mt-1">Quiz Rooms, Tic Tac Toe, Battleship — win Stars and rare items.</p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <GameCard icon={Brain} title="Quiz Rooms" desc="Multi-round cosmic trivia. Win 10 stars + 25 XP per round." players={1240} reward="+10 stars · +25 XP" color="from-cyan-500 to-blue-600">
          <QuizGame />
        </GameCard>
        <GameCard icon={Grid3x3} title="Tic Tac Toe" desc="Classic 3x3 challenge. Win 10 stars + 25 XP per round." players={540} reward="+10 stars · +25 XP" color="from-fuchsia-500 to-purple-600">
          <TicTacToeGame />
        </GameCard>
        <GameCard icon={Anchor} title="Battleship" desc="Hunt down enemy ships on a 5x5 grid. Win 10 stars + 25 XP per round." players={320} reward="+10 stars · +25 XP" color="from-emerald-500 to-teal-600">
          <BattleshipGame />
        </GameCard>
      </div>

      <Card className="bg-gradient-to-br from-amber-500/10 to-orange-500/5 border-amber-500/20">
        <CardContent className="p-5 flex items-center gap-4 flex-wrap">
          <Trophy className="text-amber-300" size={28} />
          <div className="flex-1">
            <div className="font-display font-semibold">Weekly Leaderboard</div>
            <div className="text-xs text-white/60">Top 10 game winners each week receive a Legendary gift drop.</div>
          </div>
          <Button
            variant="outline"
            onClick={() => navigate('/app/leaderboard')}
            data-testid="weekly-leaderboard-view-ranks-btn"
            className="border-white/15 bg-white/5 hover:bg-white/10 text-white rounded-full"
          >
            View Ranks
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}

function GameCard({ icon: Icon, title, desc, players, reward, color, children }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Card className="bg-[#161622] border-white/10 overflow-hidden hover:-translate-y-0.5">
        <div className={`h-32 bg-gradient-to-br ${color} relative flex items-center justify-center`}>
          <Icon className="text-white drop-shadow-lg" size={48} />
          <div className="absolute top-2 right-2 text-[10px] bg-black/30 backdrop-blur px-2 py-0.5 rounded-full flex items-center gap-1"><Users size={10} />{players}</div>
        </div>
        <CardContent className="p-4">
          <div className="font-display font-semibold">{title}</div>
          <div className="text-xs text-white/60 mt-1 line-clamp-2 h-8">{desc}</div>
          <div className="flex items-center justify-between mt-3">
            <div className="text-xs text-amber-300 flex items-center gap-1"><Trophy size={11} />{reward}</div>
            <Button size="sm" onClick={() => setOpen(true)} className="bg-white text-black hover:bg-white/90 rounded-full font-semibold"><Play size={12} className="mr-1" />Play</Button>
          </div>
        </CardContent>
      </Card>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#161622] border-white/10 text-white max-w-lg">
          <DialogHeader><DialogTitle className="font-display flex items-center gap-2"><Icon size={18} className="text-cyan-400" />{title}</DialogTitle></DialogHeader>
          <div className="mt-2">{open && children}</div>
        </DialogContent>
      </Dialog>
    </>
  );
}

// ============== Quiz ==============
function QuizGame() {
  const { refresh, bumpStats } = useAuth();
  const [bank] = useState(() => [...QUIZ_BANK].sort(() => Math.random() - 0.5).slice(0, 10));
  const [idx, setIdx] = useState(0);
  const [picked, setPicked] = useState(null);
  const [score, setScore] = useState(0);
  const [done, setDone] = useState(false);

  const q = bank[idx];
  const choose = (i) => {
    if (picked !== null) return;
    setPicked(i);
    const correct = i === q.correct;
    if (correct) setScore(s => s + 1);
    setTimeout(() => {
      if (idx === bank.length - 1) finish(correct ? score + 1 : score);
      else { setIdx(idx + 1); setPicked(null); }
    }, 900);
  };
  const finish = async (final) => {
    setDone(true);
    try {
      const { data } = await api.post('/games/gm3/complete');
      bumpStats?.({ stars: data.stars_awarded || 0, xp: data.xp_awarded || 0 });
      toast.success(`Quiz complete — ${final}/${bank.length} correct! +${data.stars_awarded} stars · +${data.xp_awarded} XP`);
      refresh && refresh();
    } catch (e) {
      const detail = e?.response?.data?.detail;
      toast(`Quiz complete — ${final}/${bank.length} correct!${detail ? ` (${detail})` : ''}`);
    }
  };

  if (done) return (
    <div className="text-center py-6">
      <Sparkles className="mx-auto text-amber-300" size={48} />
      <div className="font-display font-bold text-2xl mt-3">{score}/{bank.length}</div>
      <div className="text-white/60 text-sm mt-1">+10 stars · +25 XP earned</div>
    </div>
  );

  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <span className="text-xs text-white/50">Question {idx + 1} / {bank.length}</span>
        <span className="text-xs text-amber-300">Score: {score}</span>
      </div>
      <div className="font-display font-semibold text-lg mb-4">{q.q}</div>
      <div className="space-y-2">
        {q.a.map((opt, i) => {
          const isCorrect = picked !== null && i === q.correct;
          const isWrong = picked === i && i !== q.correct;
          return (
            <button key={i} onClick={() => choose(i)} disabled={picked !== null} className={`w-full text-left px-4 py-3 rounded-xl text-sm transition border ${isCorrect ? 'bg-emerald-500/20 border-emerald-400/50 text-emerald-200' : isWrong ? 'bg-rose-500/20 border-rose-400/50 text-rose-200' : 'bg-white/5 hover:bg-white/10 border-white/10'}`}>
              <div className="flex items-center justify-between">{opt}{isCorrect && <Check size={16} />}{isWrong && <X size={16} />}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}

// ============== Tic Tac Toe ==============
function TicTacToeGame() {
  const { refresh, bumpStats } = useAuth();
  const [board, setBoard] = useState(Array(9).fill(null));
  const [turn, setTurn] = useState('X'); // X = player
  const [winner, setWinner] = useState(null);

  const lines = [[0,1,2],[3,4,5],[6,7,8],[0,3,6],[1,4,7],[2,5,8],[0,4,8],[2,4,6]];
  const checkWinner = (b) => {
    for (const [a,c,d] of lines) if (b[a] && b[a] === b[c] && b[a] === b[d]) return b[a];
    if (b.every(Boolean)) return 'draw';
    return null;
  };

  const aiMove = (b) => {
    // try win
    for (let i = 0; i < 9; i++) if (!b[i]) { const t = [...b]; t[i] = 'O'; if (checkWinner(t) === 'O') return i; }
    // block
    for (let i = 0; i < 9; i++) if (!b[i]) { const t = [...b]; t[i] = 'X'; if (checkWinner(t) === 'X') return i; }
    // center, corners, sides
    const pref = [4, 0, 2, 6, 8, 1, 3, 5, 7].filter(i => !b[i]);
    return pref[0];
  };

  const click = (i) => {
    if (board[i] || winner || turn !== 'X') return;
    const nb = [...board]; nb[i] = 'X'; setBoard(nb);
    const w = checkWinner(nb); if (w) { setWinner(w); finish(w); return; }
    setTurn('O');
    setTimeout(() => {
      const ai = aiMove(nb);
      if (ai === undefined) return;
      const nb2 = [...nb]; nb2[ai] = 'O'; setBoard(nb2);
      const w2 = checkWinner(nb2); if (w2) { setWinner(w2); finish(w2); return; }
      setTurn('X');
    }, 400);
  };
  const finish = async (w) => {
    try {
      const { data } = await api.post('/games/gm2/complete');
      bumpStats?.({ stars: data.stars_awarded || 0, xp: data.xp_awarded || 0 });
      refresh && refresh();
      if (w === 'X') toast.success(`You won! +${data.stars_awarded} stars · +${data.xp_awarded} XP`);
      else if (w === 'O') toast(`🌱 I am Groot. Groot won this round. +${data.stars_awarded} stars · +${data.xp_awarded} XP`);
      else toast(`It\u2019s a draw. +${data.stars_awarded} stars · +${data.xp_awarded} XP`);
    } catch (e) {
      const detail = e?.response?.data?.detail;
      if (w === 'X') toast.success(`You won!${detail ? ` (${detail})` : ''}`);
      else if (w === 'O') toast(`🌱 Groot won this round.${detail ? ` (${detail})` : ''}`);
      else toast(`It\u2019s a draw.${detail ? ` (${detail})` : ''}`);
    }
  };
  const reset = () => { setBoard(Array(9).fill(null)); setTurn('X'); setWinner(null); };

  return (
    <div>
      {winner === 'O' ? (
        <div
          className="text-center text-base font-display font-extrabold mb-3 bg-gradient-to-r from-emerald-300 via-lime-300 to-amber-300 bg-clip-text text-transparent animate-pulse"
          data-testid="ttt-groot-banner"
          style={{ filter: 'drop-shadow(0 0 12px rgba(132,204,22,0.45))' }}
        >
          🌱 I am Groot — Groot Won! 🌳
        </div>
      ) : (
        <div className="text-center text-sm text-white/60 mb-3">
          {winner ? (winner === 'draw' ? 'Draw!' : 'You win!') : (turn === 'X' ? 'Your turn (X)' : 'AI thinking...')}
        </div>
      )}
      <div className="grid grid-cols-3 gap-2 max-w-xs mx-auto">
        {board.map((cell, i) => (
          <button key={i} onClick={() => click(i)} className="aspect-square rounded-xl bg-white/5 hover:bg-white/10 border border-white/10 flex items-center justify-center text-4xl font-display font-bold">
            <span className={cell === 'X' ? 'text-cyan-400' : 'text-fuchsia-400'}>{cell}</span>
          </button>
        ))}
      </div>
      <div className="text-center mt-4">
        <Button onClick={reset} variant="outline" className="border-white/15 bg-white/5 hover:bg-white/10 text-white rounded-full">New round</Button>
      </div>
    </div>
  );
}

// ============== Battleship (simplified 5x5) ==============
function BattleshipGame() {
  const { refresh, bumpStats } = useAuth();
  const SIZE = 5;
  const SHIPS = 5; // 5 single-cell ships randomly placed
  const [ships, setShips] = useState(() => placeShips());
  const [shots, setShots] = useState({}); // index -> 'hit' | 'miss'
  const [hits, setHits] = useState(0);
  const [moves, setMoves] = useState(0);
  const [awarded, setAwarded] = useState(false);
  const won = hits === SHIPS;

  function placeShips() {
    const out = new Set();
    while (out.size < SHIPS) out.add(Math.floor(Math.random() * SIZE * SIZE));
    return out;
  }

  const awardXp = async () => {
    if (awarded) return;
    setAwarded(true);
    try {
      const { data } = await api.post('/games/gm1/complete');
      bumpStats?.({ stars: data.stars_awarded || 0, xp: data.xp_awarded || 0 });
      refresh && refresh();
      toast.success(`🛡️ Victory! +${data.stars_awarded} stars · +${data.xp_awarded} XP`);
    } catch (e) {
      const detail = e?.response?.data?.detail;
      toast(`🛡️ Victory!${detail ? ` (${detail})` : ''}`);
    }
  };

  const fire = (i) => {
    if (shots[i] || won) return;
    const hit = ships.has(i);
    setShots({ ...shots, [i]: hit ? 'hit' : 'miss' });
    setMoves(m => m + 1);
    if (hit) {
      const h = hits + 1; setHits(h);
      if (h === SHIPS) {
        awardXp();
      } else {
        // Alternating Hulk + Iron Man one-liners on direct hits (Marvel easter eggs)
        const lines = ['💥 HULK SMASH!', '⚡ Thor approves!', '🛡️ Cap got him!', '🕷️ Pew-pew, parker style!', '🔥 Iron blast!'];
        toast(lines[h % lines.length]);
      }
    }
  };

  const reset = () => { setShips(placeShips()); setShots({}); setHits(0); setMoves(0); setAwarded(false); };

  return (
    <div>
      <div className="flex items-center justify-between text-xs text-white/60 mb-3">
        <span>Hits: <span className="text-emerald-300 font-semibold">{hits}/{SHIPS}</span></span>
        <span>Shots: <span className="text-cyan-300 font-semibold">{moves}</span></span>
      </div>
      <div className="grid gap-1.5 max-w-xs mx-auto" style={{ gridTemplateColumns: `repeat(${SIZE}, 1fr)` }}>
        {Array.from({ length: SIZE * SIZE }).map((_, i) => {
          const s = shots[i];
          return (
            <button key={i} onClick={() => fire(i)} disabled={!!s || won} className={`aspect-square rounded-lg border ${s === 'hit' ? 'bg-rose-500/40 border-rose-400' : s === 'miss' ? 'bg-white/5 border-white/10' : 'bg-cyan-500/10 border-cyan-400/20 hover:bg-cyan-500/20'}`}>
              <span className="text-lg">{s === 'hit' ? '\ud83d\udca5' : s === 'miss' ? '\u00b7' : ''}</span>
            </button>
          );
        })}
      </div>
      <div className="text-center mt-4">
        <Button onClick={reset} variant="outline" className="border-white/15 bg-white/5 hover:bg-white/10 text-white rounded-full">New battle</Button>
      </div>
    </div>
  );
}
